import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const LoanPortfolioReportTable: React.FC<BaseTablePropsType> = ({
	rows,
}) => {
	const loanPortfolioTableHeaders = [
		"Obligor Name",
		"Disbursed Loan Date",
		"Maturity Date",
		"Past Due Days",
		"Principal Amount",
		"Interest in Suspense",
		"Total Loan Balance",
	];
	return (
		<BaseTable headers={loanPortfolioTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell>{row?.customerName}</TableCell>
							<TableCell>{formatDate(row?.disbursementDate, false)}</TableCell>
							<TableCell>{formatDate(row?.maturityDate, false)}</TableCell>
							<TableCell>{row?.pastDueDays ?? 0}</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.principalAmount ?? 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.interestInSuspense ?? 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.totalLoanBalance ?? 0)}
							</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</BaseTable>
	);
};
